import { render, staticRenderFns } from "./PosterHallModule.vue?vue&type=template&id=7cdf5bca"
import script from "./PosterHallModule.vue?vue&type=script&lang=ts"
export * from "./PosterHallModule.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports